var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('CircleBadge'),_c('ContentHome'),_c('ContentOsteopathie'),_c('ContentBehandlung'),_c('ContentUeberMich'),_c('ContentKontakt')],1)}
var staticRenderFns = []

export { render, staticRenderFns }